export const aboutContent = {
  heroTitle: "关于风间由美",
  heroSubtitle: "用演技诠释人生，以真诚打动人心",
  heroImage: "https://readdy.ai/api/search-image?query=Elegant%20Japanese%20actress%20artistic%20portrait%2C%20soft%20warm%20backlighting%2C%20sophisticated%20atmosphere%2C%20minimalist%20composition%2C%20beautiful%20feminine%20silhouette%2C%20calm%20confident%20expression%2C%20cinematic%20photography&width=1600&height=600&seq=about-hero&orientation=landscape",
  bio: {
    title: "个人简介",
    content: `风间由美，日本知名女演员与艺人。以其精湛的演技、优雅的气质和敬业的精神，在日本演艺界享有盛誉。

自出道以来，风间由美一直秉持着对表演艺术的无限热爱与不懈追求。从最初的舞台剧演员到如今活跃于电影、电视剧、综艺节目等多个领域的全能艺人，她用自己的努力和才华，书写了一段精彩的演艺人生。

风间由美的表演风格细腻而富有层次感，无论是复杂多面的电影角色，还是轻松活泼的综艺表现，她都能游刃有余地驾驭。她对角色的深度理解和精准把握，使每一个她塑造的人物都鲜活而真实。

在演艺事业之外，风间由美也积极参与公益活动，关注女性权益和儿童教育事业，以自身影响力传递正能量。

截至2026年，风间由美已出演超过50部影视作品，多次获得重要奖项提名和荣誉，是日本演艺界当之无愧的实力派演员。`,
  },
  stats: [
    { label: "从业年限", value: "15+" },
    { label: "影视作品", value: "50+" },
    { label: "获奖提名", value: "12" },
    { label: "粉丝会员", value: "50万+" },
  ],
  milestones: [
    { year: "2010", title: "演艺生涯起步", description: "以舞台剧演员身份正式出道，开始专业演艺训练。" },
    { year: "2013", title: "首次银幕亮相", description: "在电视剧中首次出演重要角色，获得业界关注。" },
    { year: "2016", title: "首次担任女主角", description: "在电影中首次担任女主角，演技获得广泛认可。" },
    { year: "2019", title: "演艺事业突破", description: "多部作品同期上映，成为年度最受关注女演员之一。" },
    { year: "2021", title: "舞台剧回归", description: "重返舞台，出演大型舞台剧，展现全能实力。" },
    { year: "2023", title: "国际认可", description: "作品在国际电影节展映，获得海外影评人好评。" },
    { year: "2025", title: "电影学院奖提名", description: "首次获得日本电影学院奖最佳女主角提名。" },
    { year: "2026", title: "事业新高峰", description: "主演电影票房屡创新高，粉丝俱乐部会员突破50万。" },
  ],
  testimonials: [
    {
      name: "山田太郎",
      title: "知名导演",
      content: "风间由美是我合作过的最有天赋的演员之一。她对角色的理解和投入程度让人惊叹，每一个镜头都能给出超出预期的表演。",
    },
    {
      name: "田中雅美",
      title: "舞台剧导演",
      content: "由美在舞台上的表现力令人震撼。她能够完全掌控整个剧场的氛围，让每一位观众都沉浸在她的表演之中。",
    },
    {
      name: "高桥诚",
      title: "电视剧导演",
      content: "与风间由美合作是一种享受。她不仅专业敬业，更有一种将平凡剧本变得不平凡的神奇能力。",
    },
    {
      name: "影评人佐藤",
      title: "资深影评人",
      content: "风间由美的表演已经到了一个非常高的境界——她不是在表演角色，而是在理解人性。这是伟大演员的标志。",
    },
  ],
  contact: {
    email: "contact@kazama-yumi-fans.com",
    address: "日本东京都港区六本木3-2-1 演艺大楼8F",
    phone: "+81-3-1234-5678",
    socialLinks: [
      { name: "Twitter", url: "https://twitter.com/kazama_yumi", icon: "ri-twitter-x-line" },
      { name: "Instagram", url: "https://instagram.com/kazama_yumi", icon: "ri-instagram-line" },
      { name: "YouTube", url: "https://youtube.com/@kazama_yumi", icon: "ri-youtube-line" },
    ],
  },
};